export enum Action {
    POST,
    PRINT_AND_POST
}

export interface ProcessType {
    endpoint: string;
    title: string;
}
